/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import SegmentingOption from './segmenting_option'
import MCPOptions from './multiple_choice_poll_options'
import Collection from './collection'
import _ from 'underscore'

export default class SegmentingOptions extends Collection {
  get model () { return SegmentingOption }

  mcpOptions () {
    const mcpOptions = new MCPOptions(this.pluck('mcpOption'))
    mcpOptions.poll = this.poll
    return mcpOptions
  }

  maxResponseCount (opts) {
    let counts
    if (opts == null) { opts = {} }
    if (opts.includeNonResponses == null) { opts.includeNonResponses = false }

    if ((counts = this.invoke('responseCount', opts)).length) {
      return _.max(counts)
    } else {
      return undefined
    }
  }
}
